export function sum(array: number[]) {
  if (array == null || !array.length) {
    return 0;
  }
  return array.reduce((acc, num) => acc + num, 0);
}
